<template>
  <tab-item-template>
    <template #toolbar-items>
      <el-tooltip content="新規コントローラ作成" placement="bottom" v-if="isEditable">
        <v-btn icon @click="openCreateDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </el-tooltip>
    </template>

    <controller-table
        :controllers="controllers"
        @openDeleteDialog="openDeleteDialog"
        @openUpdateDialog="openUpdateDialog">
    </controller-table>

    <!-- 作成ダイアログ -->
    <simple-dialog
        v-model="dialogCreate.visible"
        title-text="コントローラ作成"
        @close="closeCreateDialog"
        @apply="createController">
      <controller-form
          v-model="dialogCreate.form">
      </controller-form>
    </simple-dialog>

    <!-- 更新ダイアログ -->
    <simple-dialog
        v-model="dialogUpdate.visible"
        title-text="コントローラ編集"
        @close="closeUpdateDialog"
        @apply="updateController">
      <controller-form
          v-model="dialogUpdate.form">
      </controller-form>
    </simple-dialog>

    <!-- 削除ダイアログ -->
    <simple-dialog
        v-model="dialogDelete.visible"
        title-text="コントローラ削除"
        title-color="delete"
        apply-text="削除"
        header-text="以下のコントローラを削除します。本当によろしいですか？"
        @close="closeDeleteDialog"
        @apply="deleteController">
      <controller-form
          v-model="dialogDelete.form"
          :readonly="true">
      </controller-form>
    </simple-dialog>
  </tab-item-template>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import ControllerTable from "@/components/pages/implementation/TerminalImplementationList/ControllerTable.vue";
import ControllerForm from "@/components/pages/implementation/TerminalImplementationList/ControllerForm.vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";

export default {
  name: "ControllerListTab",
  components: {
    TabItemTemplate,
    SimpleDialog,
    ControllerTable,
    ControllerForm
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin
  ],
  computed: {
    ...mapState('hcs/controller', ['controllers']),
    ...mapGetters({
      account: 'hcs/account'
    }),
  },
  data() {
    return {
      dialogCreate: {
        visible: false,
        form: null
      },
      dialogUpdate: {
        visible: false,
        form: null
      },
      dialogDelete: {
        visible: false,
        form: null
      },
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    load() {
      return this.$store.dispatch('hcs/controller/findList', { q: { terminalIdEq: this.account.user?.terminal?.id } })
    },
    openCreateDialog() {
      this.dialogCreate = {
        visible: true,
        form: this.defaultForm()
      };
    },
    closeCreateDialog() {
      this.dialogCreate.visible = false;
    },
    openUpdateDialog(controller) {
      this.dialogUpdate = {
        visible: true,
        form: controller
      };
    },
    closeUpdateDialog() {
      this.dialogUpdate.visible = false;
    },
    openDeleteDialog(controller) {
      this.dialogDelete = {
        visible: true,
        form: controller
      };
    },
    closeDeleteDialog() {
      this.dialogDelete.visible = false;
    },
    defaultForm() {
      return {
        terminalId: this.account.user.terminal.id,
        name: '',
        description: '',
        status: 'disconnected',
        pollingRate: null,
      }
    },
    createController() {
      this.showSnackbar({
        message: 'コントローラを作成中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/controller/create', this.dialogCreate.form)
          .then(() => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `作成に成功しました`
            });
          })
          .catch(e => {
            console.error(e);
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `作成に失敗しました`
            });
          });
    },
    updateController() {
      this.showSnackbar({
        message: 'コントローラを保存中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/controller/update', this.dialogUpdate.form)
          .then(() => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `保存に成功しました`
            });
          })
          .catch(e => {
            console.error(e);
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `保存に失敗しました`
            });
          });
    },
    deleteController() {
      this.showSnackbar({
        message: 'コントローラを削除中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/controller/delete', this.dialogDelete.form.id)
          .then(() => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `コントローラが削除されました`
            });
          })
          .catch(e => {
            console.error(e);
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `コントローラの削除に失敗しました`
            });
          });
    }
  }
}
</script>

<style scoped>

</style>
